import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { logError } from '../../common/HelperMethods';
import useCarInsuranceController from '../../../hooks/insuranceJourney/useCarInsuranceController';
import { SiteContext } from '../../../context/SiteContext';
import { useContext } from 'react';
import LoadingContainer from '../../common/LoadingContainer/LoadingContainer';

interface Props {
  displayText: string;
  documentId?: number;
  additionalClasses?: string;
  quoteId?: number;
  documentType?: string;
  policyDocumentScheme?: string;
  policyDocumentId?: string;
  policyDocumentType?: string;
  icon?: JSX.Element;
}

const InsuranceDocumentLink = ({
  displayText,
  documentId,
  additionalClasses,
  quoteId,
  documentType,
  policyDocumentScheme,
  policyDocumentId,
  policyDocumentType,
  icon
}: Props) => {
  const { getQuoteDocumentById, generateQuoteDocument, getPolicyDocument } =
    useCarInsuranceController();

  const [loading, setLoading] = useState(false);

  const { site } = useContext(SiteContext);

  const renderPdf = (base64EncodedData: string) => {
    const contents = atob(base64EncodedData);
    console.log(contents);
    const dataBytes = new Uint8Array(contents.length);

    for (let i = 0; i < contents.length; i++) {
      dataBytes[i] = contents.charCodeAt(i);
    }

    const blob = new Blob([dataBytes], { type: 'application/pdf' });

    return URL.createObjectURL(blob);
  };

  const handleDocumentLinkClick = (
    documentId?: number,
    quoteId?: number,
    documentType?: string
  ) => {
    setLoading(true);
    if (documentId) {
      getQuoteDocumentById(
        documentId,
        site.user.token,
        getQuoteDocumentByIdSuccess,
        handleError
      );
    } else if (quoteId && documentType) {
      generateQuoteDocument(
        quoteId,
        documentType,
        site.user.token,
        getQuoteDocumentByIdSuccess,
        handleError
      );
    } else if (policyDocumentType && policyDocumentScheme && policyDocumentId) {
      getPolicyDocument(
        policyDocumentScheme,
        policyDocumentId,
        policyDocumentType,
        site.user.token,
        getQuoteDocumentByIdSuccess,
        handleError
      );
    } else {
      setLoading(false);
    }
  };

  const handleError = (error: string) => {
    setLoading(false);
    logError(error);
  };

  const getQuoteDocumentByIdSuccess = (documentContent: string) => {
    setLoading(false);
    const url = renderPdf(documentContent);
    window.open(url);
  };

  return (
    <LoadingContainer loading={loading} message={'Loading...'}>
      {icon && <i>{icon}</i>}
      <Link
        id={`lnkDocument-${documentId ?? quoteId}`}
        className={`in-text ${additionalClasses ?? ''}`}
        to='#'
        onClick={() =>
          handleDocumentLinkClick(documentId, quoteId, documentType)
        }>
        {displayText}
      </Link>
    </LoadingContainer>
  );
};

export default InsuranceDocumentLink;
